/**
 * Centralized, typed access to environment variables.
 * Never read process.env directly elsewhere — import from here so the
 * surface area of config is auditable and easy to mock in tests.
 */

const env = {
  appName: process.env.REACT_APP_NAME || 'LearnX',
  appEnv: process.env.REACT_APP_ENV || 'development',
  isProduction: process.env.NODE_ENV === 'production',
  isDevelopment: process.env.NODE_ENV !== 'production',

  firebase: {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
  },

  /**
   * reCAPTCHA Enterprise site key for Firebase App Check. Empty until the site
   * is registered in the console — App Check then stays off, which is the safe
   * default: initialising it without a valid key would attach tokens the
   * backend can't verify. See functions/src/config.js for the rollout order.
   */
  appCheckSiteKey: process.env.REACT_APP_APPCHECK_SITE_KEY || '',

  /**
   * Sentry DSN. Empty disables error reporting entirely (local dev, and any
   * build made before the project is set up) — see services/monitoring.js.
   */
  sentryDsn: process.env.REACT_APP_SENTRY_DSN || '',
};

export default env;
